const routes = [
    {
      path: '/tendersure/landing',
      name: 'QedLanding',
      component: () => import('../../views/qed/landing/LandingPage.vue')
    },
]

export default routes;